<template>
<v-dialog v-model="DisplayDialog" max-width="500px" persistent @keydown.esc="No()">
    <v-card>
        <v-card-title class="headline">{{DialogTitle}}</v-card-title>
        <v-card-text>
            {{DialogContents}}
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="Loading" @click="Yes()">Yes</v-btn>
            <v-btn color="error" :loading="Loading" @click="No()">No</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: {
        DisplayDialog: {
            type: Boolean,
            required: true
        },
        DialogTitle: {
            type: String,
            required: true
        },
        DialogContents: {
            type: String,
            required: true
        },
        Loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        Yes() {
            this.$emit("Yes");
        },
        No() {
            this.$emit("No");
        }
    }
}
</script>
